


































import { Component, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component({
  components: {
    "invoices-listing": () =>
      import("@/components/app/global/invoices/invoicesListing.vue"),
    "credit-notes-table": () =>
      import("@/components/app/global/creditNotes/creditNotesTable.vue"),
    "cprod-breakdown-component": () =>
      import(`@/components/app/global/contractProducts/cProdBreakdownComp.vue`),
    "cprod-timeline-component": () =>
      import(`@/components/app/global/contractProducts/cProdTimelineComp.vue`),
    "cprod-manage-component": () =>
      import("@/components/app/global/contractProducts/cProdManageComp.vue"),
    "cprod-invoice-consolidation-component": () =>
      import(
        "@/components/app/global/contractProducts/cProdInvoiceConsolidationComp.vue"
      )
  }
})
export default class UpmindClientCProdBillingView extends Mixins(
  CProdInjectorMixin
) {
  // Computed
  public get listingProps() {
    return {
      contractId: this.cProdData.contractId,
      productId: this.cProdData.contractProductId,
      clientId: this.cProdData.contract?.client_id
    };
  }
  private mounted() {
    this.$bus.$emit("scrollClientCProdView");
  }
}
